import { render } from "./SeleccionPosicion.vue?vue&type=template&id=3d2fd83c&scoped=true"
import script from "./SeleccionPosicion.vue?vue&type=script&lang=js"
export * from "./SeleccionPosicion.vue?vue&type=script&lang=js"

import "./SeleccionPosicion.vue?vue&type=style&index=0&id=3d2fd83c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d2fd83c"]])

export default __exports__